// @format
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import facialLogo from './title.png';

import './Header.css';

const Header = ({ brandName, className, children }) => (
  <header className={classnames('Header', className)}>
    <img className="Header-logo" src={facialLogo} alt="logo" />
    {brandName && <span>{brandName}</span>}
    {children}
  </header>
);

Header.propTypes = {
  brandName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};

export default Header;



// WEBPACK FOOTER //
// ./src/modules/components/Header/Header.js